"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SingleOtpInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SingleOtpInput, _React$PureComponent);

  function SingleOtpInput() {
    _classCallCheck(this, SingleOtpInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(SingleOtpInput).apply(this, arguments));
  }

  _createClass(SingleOtpInput, [{
    key: "componentDidMount",
    // Focus on first render
    // Only when shouldAutoFocus is true
    value: function componentDidMount() {
      var input = this.input,
          _this$props = this.props,
          focus = _this$props.focus,
          shouldAutoFocus = _this$props.shouldAutoFocus;

      if (input && focus && shouldAutoFocus) {
        input.select(); // input.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var input = this.input,
          focus = this.props.focus; // Check if focusedInput changed
      // Prevent calling function if input already in focus

      if (prevProps.focus !== focus && input && focus) {
        // input.focus();
        input.select();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          focus = _this$props2.focus,
          isDisabled = _this$props2.isDisabled,
          shouldAutoFocus = _this$props2.shouldAutoFocus,
          allowAlphabets = _this$props2.allowAlphabets,
          value = _this$props2.value,
          rest = _objectWithoutProperties(_this$props2, ["focus", "isDisabled", "shouldAutoFocus", "allowAlphabets", "value"]);

      return _react["default"].createElement("input", _extends({
        type: allowAlphabets ? "text" : "number"
      }, !allowAlphabets && {
        min: 0,
        max: 9
      }, {
        maxLength: "1",
        ref: function ref(input) {
          _this.input = input;
        },
        disabled: isDisabled,
        value: value
      }, rest));
    }
  }]);

  return SingleOtpInput;
}(_react["default"].PureComponent);

exports["default"] = SingleOtpInput;

_defineProperty(SingleOtpInput, "defaultProps", {
  isDisabled: false,
  allowAlphabets: false,
  shouldAutoFocus: false,
  focus: false,
  value: ""
});

_defineProperty(SingleOtpInput, "propTypes", {
  focus: _propTypes["default"].bool,
  shouldAutoFocus: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  allowAlphabets: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
});